import Vue, { PluginFunction, PluginObject } from 'vue';
import VueRouter from 'vue-router';

declare module 'vue/types/vue' {
	interface Vue {
		$cache: CacheService
	}
}

interface CacheServiceOptions {
	router: VueRouter
}

export class CacheService {
	private $router

	public setParam(params?: any) {
		const $routerName = this.$router.history.current.name
		return this.setParamByRouterName($routerName, params)

	}

	public clearParam() {
		sessionStorage.cache = null
	}

	public deleteParamByRouterName($routerNames:string[]) {
		if(sessionStorage.cache && JSON.parse(sessionStorage.cache) !== null){
			const $storage = JSON.parse(sessionStorage.cache)
			$routerNames.forEach(routerName => {
				delete $storage[routerName]
			})
			sessionStorage.cache = JSON.stringify($storage)
		}
	}

	public getParam() {
		const $currentName = this.$router.history.current.name
		return this.getParamByRouterName($currentName)
	}

	public getParamByRouterName($routerName: string) {
		if (!sessionStorage.cache) return null
		const $param = JSON.parse(sessionStorage.cache)
		if (!$param) return null
		return Object.keys($param).includes($routerName) ? $param[$routerName] : null
	}

	public setParamByRouterName($routerName: string, params?: any) {
		if (!sessionStorage.cache || JSON.parse(sessionStorage.cache) === null) {
			sessionStorage.cache = JSON.stringify({})
		}
		const $storage = JSON.parse(sessionStorage.cache)
		const $object = {}

		$object[$routerName] = params;
		sessionStorage.cache = JSON.stringify(Object.assign($storage, $object))
	}


	public install(Vue, options?: CacheServiceOptions) {
		Vue.prototype.$cache = this;
		this.$router = options.router
	}
}
export default new CacheService()
